import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import { ApiTestQuestionResponse } from 'src/services/entity-factory/factories/AptitudeTestQuestionFactory';
import AptitudeTestSection from 'src/entities/AptitudeTestSection';

export interface ApiAptitudeTestSectionResponse {
  id: number;
  title: string;
  type: string;
  questions: ApiTestQuestionResponse[];
}

interface ApiAptitudeTestSectionCreateRequest {

}

export class AptitudeTestSectionFactory extends BaseFactory<AptitudeTestSection> {
  public toEntity(args: ApiAptitudeTestSectionResponse): AptitudeTestSection {
    return new AptitudeTestSection({
      id: args.id,
      title: args.title,
      type: args.type,
      questions: args.questions ?
        args.questions.map(
          question => this.entityFactoryFactory.aptitudeTestQuestionFactory.toEntity(question)
        ) : []
    });
  }

  public toRequest(aptitudeTestSection: AptitudeTestSection): ApiAptitudeTestSectionCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/AptitudeTestSectionFactory.tsx